import {cUtil}  from './../../../functions/util';

export class cProductItemMarinades {
  
  fieldset_marinades = document.createElement('fieldset');
  label_marinades    = document.createElement('label');
  select_marinades   = document.createElement('select');
  div_error          = document.createElement('div');
  option0            = document.createElement('option');
  option1            = document.createElement('option');
  option2            = document.createElement('option');
  option3            = document.createElement('option');
  option4            = document.createElement('option');
  option5            = document.createElement('option');
  option6            = document.createElement('option');
  option7            = document.createElement('option');

  product   : ProductData;
  parentObj : DateFieldTop;

  constructor(
    item      : OrderListItem,
    product   : ProductData,
    parent    : HTMLElement,
    parentObj : DateFieldTop,
  ) {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    this.product = product;
    this.parentObj = parentObj;

    const isSeason    = false;
    const hasMarinade = product.marinade !== '';
    
    // ---- Structure ----
    parent.append(this.fieldset_marinades);
      this.fieldset_marinades.append(this.label_marinades);
      this.fieldset_marinades.append(this.select_marinades);
        this.select_marinades.append(this.option0);
        this.select_marinades.append(this.option1);
        this.select_marinades.append(this.option2);
        this.select_marinades.append(this.option3);
        this.select_marinades.append(this.option4);
        // this.select_marinades.append(this.option5);
        if (isSeason) {
          this.select_marinades.append(this.option5);
          this.select_marinades.append(this.option6);
        }
      this.fieldset_marinades.append(this.div_error);

    // ---- Text ----
    this.label_marinades.textContent = __('Marinade'                     , 'custom');
    this.option0.textContent         = '— ' + __('keine'                 , 'custom') +' —';
    this.option1.textContent         = __('Marinade Argentina'           , 'custom');
    this.option2.textContent         = __('Marinade Kräuter Provençale'  , 'custom');
    this.option3.textContent         = __('Marinade Curry'               , 'custom');
    this.option4.textContent         = __('Dry Rub Metzgergewürz'        , 'custom');
    // this.option5.textContent         = __('Marinade Metzgergewürz'       , 'custom');
    this.option5.textContent         = __('Marinade Bärlauch'            , 'custom');
    this.option6.textContent         = __('Marinade Honig Habanero Hot'  , 'custom');

    // ---- Css ----
    this.css('fieldset_marinades');

    // ---- Other ----
    this.option0.value = '';
    this.option1.value = 'Marinade Argentina';
    this.option2.value = 'Marinade Kräuter Provençale';
    this.option3.value = 'Marinade Curry';
    this.option4.value = 'Dry Rub Metzgergewürz';
    // this.option5.value = 'Marinade Metzgergewürz';
    this.option5.value = 'Marinade Bärlauch';
    this.option6.value = 'Marinade Honig Habanero Hot';
  
    cUtil.labelIds(this.label_marinades, this.select_marinades);

    // ---- Init ----
    this.option0.selected  = item.marinade === '';
    this.option1.selected  = item.marinade === 'Marinade Argentina';
    this.option2.selected  = item.marinade === 'Marinade Kräuter Provençale';
    this.option3.selected  = item.marinade === 'Marinade Curry';
    this.option4.selected  = item.marinade === 'Dry Rub Metzgergewürz';
    // this.option5.selected  = item.marinade === 'Marinade Metzgergewürz';
    if (isSeason) {
      this.option5.selected  = item.marinade === 'Marinade Bärlauch';
      this.option6.selected  = item.marinade === 'Marinade Honig Habanero Hot';
      
    }
    const isOneSelected = 
      this.option0.selected ||
      this.option1.selected ||
      this.option2.selected ||
      this.option3.selected ||
      this.option4.selected ||
      // this.option5.selected ||
      this.option5.selected ||
      this.option6.selected;
    if (!isOneSelected) {
      this.option0.selected = true;
    }

    if (!hasMarinade) {
      this.fieldset_marinades.classList.add('c-hidden');
    }

    // ---- Events ----
    this.select_marinades.addEventListener('change', () => {
      this.parentObj.changeEvent('cProductItemMarinades_change');
    });
  }

  validateItem(silent: 'silent'|'', isSelected: boolean = true): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    if (!isSelected) return true;
    if (this.product.marinade === '') return true;

    const isEmpty = this.select_marinades.value === '';

      const errorMsg = 
      isEmpty   ? __('Wählen Sie eine Marinade.', 'custom') : 
      /*else*/    '';

    const hasError = errorMsg.length > 0;

    if (silent !== 'silent' && hasError) {
      this.div_error.textContent = errorMsg;
      this.div_error.classList.add('c--error');
      this.select_marinades.classList.add('c--error-marker');
    }
    else {
      this.div_error.textContent = '';
      this.div_error.classList.remove('c--error');
      this.select_marinades.classList.remove('c--error-marker');
    }
  
    return !hasError;
  }

  getData() {
    return this.select_marinades.value;
  }

  css<K extends keyof cProductItemMarinades>(propertyName: K): void {
    const property = this[propertyName];
    if (! (property instanceof HTMLElement)) return;
    property.classList.add(propertyName);
    property.style.gridArea = propertyName;
  }
}
